import React, {useContext, useState} from "react";
import BookingTemplate from "../../../containers/Booking/Booking.template";
import {useAPI} from "../../../hooks/useAPI";
import {API_Organization} from "../../../api/organization";
import SocketStore from "../../../stores/socket.store";
import {AuthContext} from "../../../context/AuthContext";

const BookingOrganization = () => {
    const [completed, setCompleted] = useState(false)
    const {APIRequest} = useAPI()
    const userId = useContext(AuthContext)?.token?.userId
    //Запрос на отправку заявки.
    const submit = async (form) => {
        await APIRequest(API_Organization.booking.addNewBooking(userId), form)
            .then(res => res.status === 201 && setCompleted(true)) // При статусе 200, производиться переключение состояние.
        SocketStore.addListeners(socket => socket.emit("updateVerCenter")) // Обновление всех уведомлений удостоверяющих центров
    }

    return (
        <BookingTemplate
            submit={submit}
            complete={completed}
            questions={[
                {
                    question: 'Зачем нужен сервис бронирования?',
                    answer: 'Для того, чтобы облегчить поиск и сэкономить время в выборе поставщика мед. услуг. Сервис бронирования представляет собой удобный и понятный электронный сервис, который позволяет клиенту не только найти поставщика мед. услуг за короткое время, но и в дальнейшем воспользоваться всеми преимуществами платформы.'
                },
                {
                    question: 'Как работает сервис бронирования? ',
                    answer: 'Сервис проанализирует свободные даты Мед. Центров и разошлет уведомления всем свободным организациям вашего города, кто оказывает выбранную вами услугу, что позволит в кратчайшие сроки заключить договор.'
                },
                {
                    question: 'Как быстро откликается мед. организации на заявку? ',
                    answer: 'Обычно подтверждение заявки на бронирование происходит в течение нескольких часов.'
                },
                {
                    question: 'Что будет после подтверждении заявки мед.центром?',
                    answer: 'После подтверждении заявки мед. центром с вами свяжется менеджер для уточнения всех деталей выезда.'
                },
            ]} //Список вопросов-ответов
        />
    )
}

export default BookingOrganization